/**
 * Select a Job
 */

import {Alert} from '@wandb/weave/components/Alert';
import {Select} from '@wandb/weave/components/Form/Select';
import React from 'react';

import {DEFAULT_LAUNCH_PROJECT_NAME} from './constants';
import {useAvailableJobOptions} from './hooks';
import * as S from './SelectComponents.styles';

interface SelectJobProps {
  entityName: string;
  projectName: string;
  selectedJobId: JobOption | null;
  defaultJobStr?: string;
  filterStr?: string;
  disabled?: boolean;
  onSelectJob: (job: JobOption) => void;
}

export type JobInfo = {
  jobName: string;
  jobVersion: string;
  jobProject?: string;
};

export interface JobOption {
  entity?: string;
  project?: string;
  value: string;
  label: string;
}
const OptionLabel = (props: JobOption) => {
  return (
    <S.SelectOptionLabel>
      <S.SelectOptionLabelText>{props.label}</S.SelectOptionLabelText>
    </S.SelectOptionLabel>
  );
};

export const SelectJob = ({
  entityName,
  projectName,
  selectedJobId,
  defaultJobStr,
  filterStr,
  disabled,
  onSelectJob,
}: SelectJobProps) => {
  const {jobOptions, loading} = useAvailableJobOptions(entityName, projectName);
  const isInEntityLaunchProject = projectName === DEFAULT_LAUNCH_PROJECT_NAME;
  const scopeOfSearchString = isInEntityLaunchProject ? 'entity' : 'project';
  let options = jobOptions;
  // Filter options by filterStr
  if (filterStr) {
    options = options.filter(option => {
      return option.label.toLowerCase().includes(filterStr.toLowerCase());
    });
  }

  if (options.length === 0 && !loading) {
    return (
      <Alert severity="info">
        There are no jobs in this {scopeOfSearchString} yet
      </Alert>
    );
  }

  // On some pages we might not know the job id, just str
  if (defaultJobStr != null && selectedJobId == null) {
    const foundDefault = options.find(x => x.label === defaultJobStr);
    if (foundDefault != null) {
      onSelectJob(foundDefault);
    }
  }

  const onChange = (option: JobOption | null) => {
    if (option) {
      onSelectJob(option);
    }
  };
  return (
    <div data-test="select-job">
      <Select
        data-test="select-job"
        isLoading={loading}
        options={options}
        placeholder="Select a job..."
        onChange={onChange}
        value={selectedJobId as any}
        formatOptionLabel={OptionLabel}
        isDisabled={disabled}
      />
    </div>
  );
};
